import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="archive-reason"
// Shows the "asked for removal by" name field only for the reason that needs it. The
// field is disabled while hidden: a hidden required field would block every other archive.
export default class extends Controller {
  static targets = ["select", "requester", "requesterInput", "details", "detailsInput"]
  static values = { requesterReason: String, otherReason: String }

  connect() {
    this.apply()
  }

  sync() {
    const input = this.apply()
    if (input) input.focus()
  }

  apply() {
    const requesterNeeded = this.selectTarget.value === this.requesterReasonValue
    this.toggleField(this.requesterTarget, this.requesterInputTarget, requesterNeeded)

    const detailsNeeded = this.selectTarget.value === this.otherReasonValue
    this.toggleField(this.detailsTarget, this.detailsInputTarget, detailsNeeded)

    if (requesterNeeded) return this.requesterInputTarget
    if (detailsNeeded) return this.detailsInputTarget
    return null
  }

  toggleField(container, input, needed) {
    container.classList.toggle("d-none", !needed)
    input.disabled = !needed
    input.required = needed
  }
}
